import React from 'react';

let ReleaseNotesContext: React.Context<string>;
export class ReleaseNotesGetter {
    public releaseNotes: any;
    public async getReleaseNotes() {
        this.releaseNotes = await fetch('assets/release-notes.txt').then((r) => r.text());
        ReleaseNotesContext = React.createContext(this.releaseNotes);
        return this.releaseNotes;
    }
}

const getReleaseNotesContext = function () {
    return ReleaseNotesContext;
};
export default getReleaseNotesContext;
